import { create } from 'zustand';

export const useAdminsBarStore = create((set) => ({
  isOpen: true,
  toggleDrawer: () => set((state) => ({ isOpen: !state.isOpen })),
  setIsOpen: (isOpen) => set({ isOpen }),
}));
